import { Actor, AnonymousIdentity, HttpAgent, Identity } from "@dfinity/agent";
import {
  idlFactory as marketplace_canister,
  canisterId as marketplace_canister_id,
} from "dfx-generated/marketplace_canister";
import { Ed25519KeyIdentity } from "@dfinity/identity";
import { AuthClient } from "@dfinity/auth-client";
import { Principal } from "@dfinity/agent/lib/cjs/idl";
import mockData from "./mocks";
import fungible_token from "@origyn-sa/common-ui/src/api/ic-agent/fungible_token_canister_v7.did";
import non_fungible_token from "@origyn-sa/common-ui/src/api/ic-agent/non_fungible_token_canister.did";
// import marketplace_token from "@origyn-sa/common-ui/src/api/ic-agent/marketplace_canister.did";

// const non_fungible_token_id = "avf3c-yiaaa-aaaab-qaa5a-cai";
// export const marketplace_token_id = "lmspi-oyaaa-aaaab-qabca-cai"; // barry
const KEY_LOCALSTORAGE_KEY = "ic-identity";
console.log({
  marketplace_canister,
  marketplace_canister_id,
  KEY_LOCALSTORAGE_KEY,
});

export const canistersFactoryMap = {
  FT: fungible_token,
  NFT: non_fungible_token,
  MARKET: marketplace_canister,
};

// export class CustomCanisterClient {
//   debug = false;
//   authClient: AuthClient | undefined;
//   actor: any;
//   agent: any;
//   // canisterId: string;
//   // principal: string;

//   constructor(canisterId: string, Principal?: string) {
//     this.debug = process.env.NODE_ENV !== "production";
//     // this.canisterId = canisterId;
//     // this.principal = Principal || "aaaaa-aaa";
//     this.createActor();
//   }

//   async create(forceLogin: boolean) {
//     // this.actor = mockData;

//     // if (identity && !identity.getPrincipal().isAnonymous()) {
//     //   console.debug("setIdentity");
//     //   this.setIdentity(identity);
//     // } else {
//     //   if (this.debug) {
//     //     // @ts-ignore
//     //     this.createActor(getIdentity());
//     //   } else {
//     //     this.createActor();
//     //   }
//     // }
//     this.authClient = await AuthClient.create();
//     if (!this.debug && forceLogin) {
//       console.debug("before::authClient.login");
//       await this.authClient.login({
//         onSuccess: () => {
//           window.location.reload();
//         },
//         maxTimeToLive: 86400000000000n, // 24 hours
//       });
//     }
//     const isAuthenticated = await this.authClient.isAuthenticated();
//     console.debug({ isAuthenticated });
//     const identity = await this.authClient.getIdentity();
//     console.debug({ identity });
//     if (identity && !identity.getPrincipal().isAnonymous()) {
//       console.debug("setIdentity");
//       this.setIdentity(identity);
//     } else {
//       console.debug("anonIdentity");
//       if (this.debug) {
//         // @ts-ignore
//         this.createActor(getIdentity());
//       } else {
//         this.createActor();
//       }
//     }
//   }

//   setIdentity(identity?: Identity) {
//     console.debug("setIdentity", identity);
//     if (identity && !identity.getPrincipal().isAnonymous()) {
//       if (this.debug) {
//         this.createActor(getIdentity());
//       } else {
//         this.createActor(identity);
//       }
//     } else {
//       if (this.debug) {
//         console.debug("debug setIdentity");
//         this.createActor(getIdentity());
//       }
//     }
//   }

//   createActor(identity?: Identity) {
//     console.debug("createActor", identity);
//     this.agent = null;
//     if (this.debug) {
//       this.agent = new HttpAgent({
//         host: "http://127.0.0.1:8000",
//         identity: identity,
//       });
//     } else {
//       this.agent = new HttpAgent({
//         identity: identity,
//       });
//     }
//     this.actor = Actor.createActor(marketplace_canister, {
//       agent: this.agent,
//       canisterId: marketplace_canister_id,
//     });
//   }

//   logout() {
//     if (this.debug) {
//       localStorage.removeItem(KEY_LOCALSTORAGE_KEY);
//       this.authClient?.logout();
//     }
//     this.authClient?.logout({ returnTo: "/" });
//     location.reload();
//   }

//   getNewMarketplaceActor(marketplaceCanisterId: string) {
//     return Actor.createActor(marketplace_canister, {
//       agent: this.agent,
//       canisterId: marketplaceCanisterId,
//     });
//   }

//   getNewNftActor(nftCanisterId: string) {
//     return Actor.createActor(non_fungible_token, {
//       agent: this.agent,
//       canisterId: nftCanisterId,
//     });
//   }
// }

export class ICPClient {
  debug = false;
  authClient: AuthClient | undefined;
  actor: any;
  agent: any;
  // canisterId: string;
  // principal: string;

  constructor() {
    this.debug = process.env.NODE_ENV !== "production";
    // this.canisterId = canisterId;
    // this.principal = Principal || "aaaaa-aaa";
    this.createActor();
  }

  static getCanisterId() {
    return marketplace_canister_id;
  }

  async create(forceLogin: boolean) {
    // this.actor = mockData;

    // if (identity && !identity.getPrincipal().isAnonymous()) {
    //   console.debug("setIdentity");
    //   this.setIdentity(identity);
    // } else {
    //   if (this.debug) {
    //     // @ts-ignore
    //     this.createActor(getIdentity());
    //   } else {
    //     this.createActor();
    //   }
    // }
    this.authClient = await AuthClient.create();
    if (!this.debug && forceLogin) {
      console.debug("before::authClient.login");
      await this.authClient.login({
        onSuccess: () => {
          window.location.reload();
        },
        maxTimeToLive: 86400000000000n, // 24 hours
      });
    }
    const isAuthenticated = await this.authClient.isAuthenticated();
    console.debug({ isAuthenticated });
    const identity = await this.authClient.getIdentity();
    console.debug({ identity });
    if (identity && !identity.getPrincipal().isAnonymous()) {
      console.debug("setIdentity");
      this.setIdentity(identity);
    } else {
      console.debug("anonIdentity");
      if (this.debug) {
        // @ts-ignore
        this.createActor(getIdentity());
      } else {
        this.createActor();
      }
    }
  }

  setIdentity(identity?: Identity) {
    console.debug("setIdentity", identity);
    if (identity && !identity.getPrincipal().isAnonymous()) {
      if (this.debug) {
        this.createActor(getIdentity());
      } else {
        this.createActor(identity);
      }
    } else {
      if (this.debug) {
        console.debug("debug setIdentity");
        this.createActor(getIdentity());
      }
    }
  }

  createActor(identity?: Identity) {
    console.debug("createActor", identity);
    this.agent = null;
    if (this.debug) {
      this.agent = new HttpAgent({
        // host: "http://127.0.0.1:8000",
        host: "https://ic0.app",
        identity: identity,
      });
    } else {
      this.agent = new HttpAgent({
        identity: identity,
      });
    }
    this.actor = Actor.createActor(marketplace_canister, {
      agent: this.agent,
      canisterId: marketplace_canister_id,
    });
  }

  getNewMarketplaceActor(marketplaceCanisterId: string): any {
    return Actor.createActor(marketplace_canister, {
      agent: this.agent,
      canisterId: marketplaceCanisterId,
    });
  }

  getNewFtActor(ftCanisterId: string): any {
    return Actor.createActor(fungible_token, {
      agent: this.agent,
      canisterId: ftCanisterId,
    });
  }

  logout() {
    if (this.debug) {
      localStorage.removeItem(KEY_LOCALSTORAGE_KEY);
      this.authClient?.logout();
    }
    this.authClient?.logout({ returnTo: "/" });
    location.reload();
  }

  getNewNftActor(nftCanisterId: string): any {
    return Actor.createActor(non_fungible_token, {
      agent: this.agent,
      canisterId: nftCanisterId,
    });
  }
}
export let client = new ICPClient();

function createIdentity(): Ed25519KeyIdentity {
  console.debug("createIdentity");
  let key = Ed25519KeyIdentity.generate();
  localStorage.setItem(KEY_LOCALSTORAGE_KEY, JSON.stringify(key));
  return key;
}

export function getIdentity(): Ed25519KeyIdentity {
  console.debug("getIdentity");
  const maybeIdentityStorage = localStorage.getItem(KEY_LOCALSTORAGE_KEY);
  if (maybeIdentityStorage) {
    try {
      let key = Ed25519KeyIdentity.fromJSON(maybeIdentityStorage);
      return key;
    } catch (e) {
      console.error("fromJSON failed");
      localStorage.removeItem(KEY_LOCALSTORAGE_KEY);
    }
  }
  return createIdentity();
}
